import dcmjs from "dcmjs";
import { Marker } from "features/patients/quantification/components/Marker";
import { CSSProperties } from "react";
import { Types } from "@cornerstonejs/core";
// @ts-ignore
const { Colors } = dcmjs.data;

// COPY FROM : https://github.com/dcmjs-org/dcmjs/blob/c209047861d2ef6c17526c6d1e29d5db7e895b29/src/adapters/VTKjs/Segmentation.js#L6
export function lab2rgba(
  lab: dcmjs.data.SegMetadata["RecommendedDisplayCIELabValue"],
): Types.Color {
  const rgba = Colors.dicomlab2RGB(lab).map((x: number) => Math.round(x * 255));
  rgba.push(255);
  return rgba;
}

export function segmentColorsToCSS(segments: Marker["segments"]) {
  const colors = segments.map((s) => {
    // DICOM: CIELab → RGBA
    if (s.RecommendedDisplayCIELabValue) {
      return lab2rgba(s.RecommendedDisplayCIELabValue).join(",");
    }
    // NIfTI: 直接用 roiSummary 的 RGB
    if ((s as any)._rgbColor) {
      const [r, g, b] = (s as any)._rgbColor;
      return `${r},${g},${b},255`;
    }
    // Fallback
    return "255,255,255,255";
  });

  let style: CSSProperties = {};
  if (colors.length === 1) {
    style = { color: `rgb(${colors[0]})`, stroke: `rgb(${colors[0]})` };
  } else if (new Set(colors).size === 1) {
    style = { color: `rgb(${colors[0]})`, stroke: `rgb(${colors[0]})` };
  }
  return style;
}

export const bgDepth = ["bg-stone-700", "bg-stone-800", "bg-stone-900"];
export const shadowDepth = [
  "shadow-stone-750",
  "shadow-stone-850",
  "shadow-stone-950",
];
